<p-drawer
  #drawer
  [visible]="this.visible()"
  appendTo="body"
  (onHide)="this.visibleChange.emit(false)"
  [closeOnEscape]="true"
  [position]="'right'"
  [closable]="false"
  [modal]="true"
  styleClass="w-100 w-md-75"
>
  <ng-template #header>
    <h3 i18n="@@add-mcp-server-engine">MCP-Server hinzufügen (Engine)</h3>
  </ng-template>
  <ng-template #content>
    <form
      [formGroup]="form"
      class="d-flex flex-column"
    >
      <div class="d-flex flex-column gap-3 form-content">
        <div class="d-flex flex-row gap-2">
          <label
            for="managedEnabled"
            i18n="@@enabled"
          >Standardmäßig aktiv</label>
          <p-toggleswitch
            id="managedEnabled"
            formControlName="enabled"
          />
        </div>
        <p-floatlabel variant="on">
          <p-select
            fluid
            id="managed"
            [options]="mcpService.managedServers"
            optionLabel="label"
            optionValue="name"
            formControlName="toolName"
            required
            (onChange)="this.loadSelectedServerTools($event.value)"
          >
            <ng-template
              #item
              let-item
            >
              <div class="d-flex flex-column">
                <span>{{ item.label }}</span>
                @if(item.name === "reflactTrain"){
                <small
                  class="text-muted"
                  i18n="@@reflact-train-expert-option-hint"
                >Für erfahrene Nutzer/Admins von reflact Train</small>
                }
              </div>
            </ng-template>
          </p-select>
          <label
            for="managed"
            i18n="@@mcp-server"
          >MCP-Server</label>
        </p-floatlabel>
        @if(form.get("toolName")?.value === "reflactTrain"){
        <p-message
          severity="warn"
          styleClass="my-1"
        >
          <i class="ri-alert-line"></i>
          <span i18n="@@reflact-train-expert-config-hint">
            Diese Einstellung ist für erfahrene Nutzer bzw. Admins von reflact Train gedacht. Label und
            Server-URL musst du selbst kennen und korrekt eintragen.
          </span>
        </p-message>
        <p-floatlabel variant="on">
          <input
            pInputText
            fluid
            id="reflactTrainLabel"
            formControlName="serverLabel"
            [pKeyFilter]="serverLabelPattern"
          />
          <label
            for="reflactTrainLabel"
            i18n="@@reflact-train-label"
          >Label</label>
        </p-floatlabel>
        @if(form.get("serverLabel")?.hasError("pattern") || form.get("serverLabel")?.hasError("required")){
        <p-message
          severity="error"
          styleClass="my-1"
        >
          <i class="ri-error-warning-line"></i>
          <span i18n="@@reflact-train-label-pattern-hint">
            Das Label darf nur Buchstaben, Zahlen, Unterstriche und Bindestriche enthalten und muss mit
            einem Buchstaben beginnen.
          </span>
        </p-message>
        }
        <p-floatlabel variant="on">
          <input
            pInputText
            fluid
            id="reflactTrainUrl"
            formControlName="serverUrl"
            (blur)="this.loadToolsFromUrl(this.form.get('serverUrl')?.value)"
          />
          <label
            for="reflactTrainUrl"
            i18n="@@reflact-train-url"
          >Server-URL</label>
        </p-floatlabel>
        @if(form.get("serverUrl")?.hasError("domainMismatch")){
        <p-message
          severity="error"
          styleClass="my-1"
        >
          <i class="ri-error-warning-line"></i>
          <span i18n="@@reflact-train-domain-mismatch-hint">
            Alle reflact-Train-MCPs dieses Bots müssen dieselbe Server-Domain verwenden, da der Login
            systemweit gilt.
          </span>
        </p-message>
        }
        <div class="d-flex flex-row gap-2">
          <label
            for="reflactTrainRequiresAuth"
            i18n="@@reflact-train-requires-auth"
          >Authentifizierung erforderlich</label>
          <p-toggleswitch
            id="reflactTrainRequiresAuth"
            formControlName="requiresAuth"
          />
        </div>
        <p-floatlabel variant="on">
          <input
            pInputText
            fluid
            id="reflactTrainAccountKey"
            formControlName="accountKey"
          />
          <label
            for="reflactTrainAccountKey"
            i18n="@@reflact-train-account-key"
          >Account Key (optional)</label>
        </p-floatlabel>
        }
        @if(this.serverTools().length > 0) {
        <p-table
          [value]="this.serverTools()"
          [(selection)]="this.selectedServerTools"
          dataKey="name"
          styleClass="flex-grow-1 mcp-tools-table"
        >
          <ng-template #header>
            <tr>
              <th style="padding-left: unset">Tool</th>
              <th class="approval-column">
                <p-floatlabel variant="on">
                  <p-select
                    styleClass="approval-select"
                    id="globalApproval"
                    [options]="globalToolApprovalOptions"
                    optionLabel="label"
                    optionValue="value"
                    optionDisabled="disabled"
                    appendTo="body"
                    [ngModel]="globalToolApproval()"
                    (ngModelChange)="setGlobalToolApproval($event)"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <label
                    for="globalApproval"
                    i18n="@@mcp-user-approval-all"
                  >User approval (alle Tools)</label>
                </p-floatlabel>
              </th>
              <th class="checkbox-column">
                <div class="d-flex justify-content-end">
                  <p-tableHeaderCheckbox />
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template
            #body
            let-tool
          >
            <tr>
              <td style="padding-left: unset">
                <div class="d-flex flex-column">
                  <span>{{ tool.title }} ({{ tool.name }})</span>
                  <small>{{ tool.description }}</small>
                </div>
              </td>
              <td class="approval-column">
                <p-select
                  styleClass="approval-select"
                  [options]="toolApprovalOptions"
                  optionLabel="label"
                  optionValue="value"
                  appendTo="body"
                  [ngModel]="getToolApproval(tool.name)"
                  (ngModelChange)="setToolApproval(tool.name, $event)"
                  [ngModelOptions]="{ standalone: true }"
                />
              </td>
              <td class="checkbox-column">
                <div class="d-flex justify-content-end">
                  <p-tableCheckbox [value]="tool" />
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
        }
        @if(form.get("toolName")?.value === "docsearcher"){
        <label i18n="@@searchable-documents">Durchsuchbare Dokumente</label>

        <p-picklist
          [source]="sourceDocuments()"
          [target]="targetDocuments()"
          dataKey="_id"
          [dragdrop]="true"
          [responsive]="true"
          [showSourceControls]="false"
          [showTargetControls]="false"
          (onMoveAllToSource)="targetChange()"
          (onMoveAllToTarget)="targetChange()"
          (onMoveToSource)="targetChange()"
          (onMoveToTarget)="targetChange()"
        >
          <ng-template
            let-item
            #item
          >
            {{ item.skillId }}
          </ng-template>
        </p-picklist>
        }
        @if(form.get("toolName")?.value === "ntfy"){
        <p-message
          severity="info"
          styleClass="my-1"
        >
          <i class="ri-information-line"></i>
          <span i18n="@@ntfy-topic-hint">
            Der Bot muss über die Bot-Instruktionen oder eine versteckte Nachricht wissen, wann er eine
            Nachricht senden soll und an welches ntfy-Topic. Da ntfy-Topics öffentlich sind, empfiehlt sich
            ein zufälliger, schwer zu erratender Topic-Name.
          </span>
          <div class="d-flex align-items-center gap-2 mt-2">
            <p-button
              size="small"
              severity="secondary"
              [outlined]="true"
              icon="ri-refresh-line"
              label="Zufälliges Topic vorschlagen"
              i18n-label="@@suggest-ntfy-topic"
              (onClick)="this.suggestNtfyTopic()"
            ></p-button>
            <app-manual-link href="/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Skills/MCP-Server#ntfy"></app-manual-link>
          </div>
          @if(this.suggestedNtfyTopic()){
          <div class="d-flex align-items-center gap-2 mt-2">
            <input
              pInputText
              class="w-100"
              [value]="this.suggestedNtfyTopic()"
              [disabled]="true"
            >
            <p-button
              severity="secondary"
              [outlined]="true"
              icon="ri-file-copy-fill"
              pTooltip="Topic kopieren"
              i18n-pTooltip="@@copy-ntfy-topic-tooltip"
              (onClick)="this.copySuggestedTopic()"
            ></p-button>
          </div>
          }
        </p-message>
        }
        <p-button
          label="Speichern"
          [disabled]="!this.form.valid|| this.form.value.allowed_tools.length === 0"
          severity="primary"
          styleClass="align-self-start"
          (click)="this.submit()"
          type="submit"
        />
      </div>
    </form>
  </ng-template>
</p-drawer>